<mat-card class="portal-page-heading mb-4">
  <mat-card-content>
    <div class="flex flex-row flex-wrap justify-start items-center gap-4">
      <mat-icon class="portal-heading-icon" fontIcon="local_hospital"></mat-icon>
      <h1 class="portal-page-title">Hospitals / SICF (Special Inpatient Care Facilities)</h1>
      <div *ngIf="license.id > 0" class="ml-auto flex flex-wrap gap-2">
        <button type="button" mat-raised-button color="primary" [disabled]="snapshot.exporting || loading"
                (click)="exportSnapshot()">{{ snapshot.exporting ? 'Exporting…' : 'Export application PDF' }}</button>
        <button type="button" mat-raised-button color="accent" [disabled]="snapshot.exporting || savingStep || submitting"
                (click)="closeLicense()">Close</button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<app-hospital-snapshot></app-hospital-snapshot>

<div class="hospital-claim-card-container flex flex-col pb-4 gap-2">
  <!--
    Claim An Existing License
  -->
  <mat-card *ngIf="license.id === 0">
    <mat-card-content>
      <div class="flex flex-col">

        <div class="flex flex-col md:flex-row">
          <span class="text-xl font-bold">Claim an Existing License</span>
        </div>

        <form [formGroup]="requestForm">
          <div class="flex flex-col pt-4 gap-2">

            <div class="flex flex-col md:flex-row md:max-2xl:flex-wrap md:gap-4">
              <mat-form-field>
                <mat-label>Owner Name</mat-label>
                <input matInput formControlName="owner">
                <mat-error *ngIf="requestForm.get('owner')?.invalid">
                  Owner Required
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>License Number</mat-label>
                <input matInput formControlName="licenseNumber">
                <mat-error *ngIf="requestForm.get('licenseNumber')?.hasError('invalidLicense')">
                  Cannot find license
                </mat-error>
              </mat-form-field>
            </div>

            <div class="flex flex-col md:flex-row md:max-2xl:flex-wrap md:gap-4">
              <mat-form-field>
                <mat-label>Street</mat-label>
                <input matInput formControlName="street">
                <mat-error *ngIf="requestForm.get('street')?.invalid">
                  You must provide a street address
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>City</mat-label>
                <input matInput formControlName="city">
                <mat-error *ngIf="requestForm.get('city')?.invalid">
                  You must provide a city
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>State</mat-label>
                <mat-select formControlName="state">
                  <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                </mat-select>
                <mat-error *ngIf="requestForm.get('state')?.invalid">
                  Please select a state
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Zip</mat-label>
                <input matInput formControlName="zip">
                <mat-error *ngIf="requestForm.get('zip')?.hasError('required')">
                  Zip is required
                </mat-error>
                <mat-error *ngIf="requestForm.get('zip')?.hasError('pattern')">
                  Zipcode should match this format: 99999 or 99999-1234
                </mat-error>
              </mat-form-field>
            </div>

            <div class="flex flex-col gap-2" *ngIf="requestForm.get('ownerChange')?.value">
              <span class="font-semibold">An In-Home Care agency is defined in Oregon Revised Statute (ORS) 443.315 as:
              an agency primarily engaged in providing in-home care services for compensation to an
              individual in that individual's place of residence.” Inhome care agency”
              does not include a home health agency or portion of an agency providing home health services as defined in ORS 443.005.</span>
              <span>1. I have read and I understand the In-Home Care licensure requirements
                set forth in ORS 443.305 to 443.350 and OARs Chapter 333, Division 536.</span>
              <span>2. Written policies and procedures, including applicable forms and curriculums,
                have been developed to direct all administrative, personnel, and client care operations of the agency.
                The policies and procedures are complete, clear, and ensure compliance with the in-home care agency OARs.</span>
              <span>3. Client care and documentation systems have been developed and implemented to ensure compliance with the In-Home Care licensure OARs.</span>
              <span>4. Personnel management and documentation systems have been developed and implemented to
                ensure employees meet all screening, qualification, orientation, and training requirements consistent with the in-home care agency OARs.</span>
              <span>5. Branch offices operated by the IHC are managed as required by the In-Home Care OARs.
                Systems to ensure that the parent IHC maintains control and oversight of the branch office(s) have been developed and implemented.</span>
              <span class="font-semibold">I attest, under penalties of perjury, that I have answered all the above questions to the best of my knowledge and belief;
                and that this information is true, correct and complete. I assume full responsibility for the ongoing operations of the IHC,
                including all branch offices, and its compliance with the applicable OARs.</span>
              <div class="flex flex-col md:flex-row gap-4 items-center">
                <mat-form-field class="md:w-1/3 h-20">
                  <mat-label>Signature</mat-label>
                  <input matInput formControlName="signature" (blur)="validateLicenseRequestSignature()">
                  <mat-error *ngIf="requestForm.get('signature')?.invalid">
                    Signature Required
                  </mat-error>
                </mat-form-field>

                <div class="flex flex-col gap-2 md:w-1/3">
                  <!-- <span class="font-semibold">Date Signed</span> -->
                  <mat-form-field>
                    <input placeholder="Date Signed" formControlName="dateSigned" matInput [matDatepicker]="dateSigned"
                           [max]="sharedService.today" (blur)="validateLicenseRequestDate()" />
                    <mat-datepicker-toggle matSuffix [for]="dateSigned"></mat-datepicker-toggle>
                    <mat-datepicker #dateSigned>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                    <mat-error *ngIf="requestForm.get('dateSigned')?.invalid">
                      Invalid Date
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

          </div>
        </form>
        <div class="flex flex-col md:flex-row">
          <button class="ml-auto" *ngIf="requestForm.valid" type="button" mat-button color="primary" (click)="createLicenseRequest()">Claim</button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<div class="grid grid-cols-[repeat(auto-fill,minmax(420px,1fr))] gap-4 pb-4" *ngIf="licenseRequests.length > 0 && license.id === 0">
  <div *ngFor="let request of licenseRequests">
    <mat-card class="w-full">
      <mat-card-content>
        <div class="flex flex-col md:flex-row">
          <span class="text-xl font-bold">License Claim Request</span>
          <button class="ml-auto" type="button" mat-button color="warn" (click)="cancelLicenseRequest(request)">Cancel Request</button>
        </div>
        <div class="flex flex-col">
          <div class="flex flex-row items-center gap-4">
            <span class="text-lg font-semibold md:w-1/3">Owner Name</span>
            <span>{{request.owner}}</span>
          </div>
          <div class="flex flex-row items-center gap-4">
            <span class="text-lg font-semibold md:w-1/3">License Number</span>
            <span>{{request.licenseNumber}}</span>
          </div>
          <div *ngIf="!request.denied" class="flex flex-row items-center gap-4">
            <span class="text-lg font-semibold md:w-1/3">Request</span>
            <span class="portal-warning">Pending</span>
          </div>
          <div *ngIf="request.denied" class="flex flex-col">
            <span class="text-lg font-semibold portal-error">Claim Request Denied</span>
            <div class="flex flex-row gap-4 items-center">
              <span class="text-lg font-semibold">Reason</span>
              <span>{{request.deniedReason}}</span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div class="flex flex-row gap-8" *ngIf="showCreateLicense && license.id === 0">
  <mat-card >
    <mat-card-content>
      <span class="text-xl font-bold">No Licenses or Applications Found</span>
    </mat-card-content>
  </mat-card>
</div>

<div class="hospital-license-grid grid grid-cols-[repeat(auto-fill,minmax(420px,1fr))] gap-4" *ngIf="licenses.length > 0 && license.id === 0">
  <div *ngFor="let license of licenses">
    <mat-card class="hospital-license-card w-full">
      <mat-card-header>
        <mat-card-title>
          <div class="hospital-license-card-heading flex flex-row gap-4 items-center">
            <span class="text-xl font-bold">{{license.isSicf? 'SICF' : 'Hospital'}} License</span>
            <div class="flex flex-row md:gap-2 right-8">
              <button *ngIf="canSelect(license)" type="button" mat-button color="primary"
                (click)="selectLicense(license)">Select</button>
              <button *ngIf="canRenew(license) && license.licenseId" type="button" mat-button color="accent"
                (click)="renewLicense(license.licenseId)">Begin Renewal</button>
            </div>
          </div>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="flex flex-col">
          <div class="flex flex-row justify-start items-center gap-4">
            <span class="text-base font-semibold w-1/3">{{licenseIsApproved(license.statuses)? 'License Number' : 'Pending License' }}</span>
            <span class="text-base" id="licenseId">{{license.licenseId}}</span>
            <button *ngIf="license.licenseId" mat-icon-button (click)="sharedService.copyToClipboard(license.licenseId)" color="primary"
              matTooltip="Copy to Clipboard" matTooltipShowDelay=800 aria-label="Copy to Clipboard">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
          <div class="flex flex-row justify-start items-center gap-4">
            <span class="text-base font-semibold w-1/3">Facility Name</span>
            <span>{{ license.entityName }}</span>
          </div>
          <div class="flex flex-row justify-start items-center gap-4">
            <span class="text-base font-semibold w-1/3">Classification</span>
            <span>{{ license.classification }}</span>
          </div>
          <div class="flex flex-row justify-start items-center gap-4">
            <span class="text-base font-semibold w-1/3">Status</span>
            <div class="flex flex-row gap-2">
              <div *ngFor="let status of license.statuses">
                <span class="text-lg"
                      [ngClass]="status.label === sharedService.approved? 'portal-success' :
                                 status.label === sharedService.renewal? 'portal-warning' : ''">{{status.label}}</span>
              </div>
            </div>
          </div>
          <div class="flex flex-row gap-4">
            <span class="text-base font-semibold w-1/3">Issued Date</span>
            <span class="text-base">{{license.approvedDate | date}}</span>
          </div>
          <div class="flex flex-row gap-4">
            <span class="text-base font-semibold w-1/3">Expiration Date</span>
            <span class="text-base">{{license.expirationDate | date}}</span>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div *ngIf="license.id > 0">
  <p *ngIf="savingStep" role="status">Saving location changes…</p>
  <mat-stepper [attr.inert]="savingStep ? '' : null" [orientation]="sharedService.isMobile? 'vertical' : 'horizontal'" #Stepper linear (selectionChange)="changeStep($event)">
    <mat-step *ngIf="approved">
      <ng-template matStepLabel>
        <span matTooltip="Services" matTooltipPosition="below" [matTooltipShowDelay]="500">Documents</span>
      </ng-template>
      <div class="md:w-1/2">
        <document
          [entityId]="license.id"
          [entityType]="sharedService.hospitalLicense"
          [editable]="false"
          [statuses]="license.statuses"
          [types]="hospitalDocumentTypes">
        </document>
      </div>
    </mat-step>

    <!--
      Begin Application
    -->
    <mat-step>
      <ng-template matStepLabel>
        <span matTooltip="Begin Application" matTooltipPosition="below" [matTooltipShowDelay]="500">Begin</span>
      </ng-template>
      <form [formGroup]="classificationForm">
        <div class="flex flex-col md:flex-row gap-4">
          <div class="flex flex-col gap-4 md:w-1/2">
            <span class="text-lg font-semibold">Select a facility type:</span>
            <mat-form-field appearance="fill" class="flex-col gap-2">
              <input matInput formControlName="isSicf" style="display: none;">
              <mat-radio-group aria-labelledby="is sicf" formControlName="isSicf" class="flex flex-col gap-2" (change)="clearClassification()">
                <mat-radio-button [value]="false">
                  <span class="font-semibold text-lg underline pr-4">Hospital</span>
                </mat-radio-button>
                <mat-radio-button [value]="true">
                  <span class="font-semibold text-lg underline pr-4">SICF (Special Inpatient Care Facility)</span>
                </mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="classificationForm.get('isSicf')?.invalid">
                You must select a facility type
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex flex-col gap-4 md:w-1/2">
            <div class="flex flex-col md:flex-row gap-4 items-center">
              <span class="text-lg font-semibold">Select the classification level you are applying for</span>
            </div>
            <div class="flex flex-col" *ngIf="classificationForm.get('isSicf')?.value">
              <mat-form-field appearance="fill" class="flex-col gap-2">
                <input matInput formControlName="classification" style="display: none;">
                <mat-radio-group aria-labelledby="classification" formControlName="classification" class="flex flex-col gap-2">
                  <mat-radio-button value="Drug Alcohol Treatment Center">
                    <span class="font-semibold text-lg underline pr-4">Drug/Alcohol Treatment Center</span>
                  </mat-radio-button>
                  <mat-radio-button value="Rehabilitation Hospital">
                    <span class="font-semibold text-lg underline pr-4">Rehabilitation Hospital</span>
                  </mat-radio-button>
                  <mat-radio-button value="Inpatient Hospice">
                    <span class="font-semibold text-lg underline pr-4">Inpatient Hospice</span>
                  </mat-radio-button>
                  <mat-radio-button value="Religious Institution">
                    <span class="font-semibold text-lg underline pr-4">Religious Institution</span>
                  </mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="classificationForm.get('classification')?.invalid">
                  You must select a classification level
                </mat-error>
              </mat-form-field>
            </div>
            <div class="flex flex-col" *ngIf="!classificationForm.get('isSicf')?.value">
              <mat-form-field appearance="fill" class="flex-col gap-2">
                <input matInput formControlName="classification" style="display: none;">
                <mat-radio-group aria-labelledby="classification" formControlName="classification" class="flex flex-col gap-2">
                  <mat-radio-button value="General Hospital">
                    <span class="font-semibold text-lg underline pr-4">General Hospital</span>
                    <span>See <a href="https://secure.sos.state.or.us/oard/viewSingleRule.action?ruleVrsnRsn=312427" target="_blank" rel="noreferrer noopener" style="word-break: break-all;
                    white-space: normal;">OAR 333-500-0032(2)(a)</a></span>
                  </mat-radio-button>
                  <mat-radio-button value="Psychiatric Hospital">
                    <span class="font-semibold text-lg underline pr-4">Psychiatric Hospital</span>
                    <span>See <a href="https://secure.sos.state.or.us/oard/viewSingleRule.action?ruleVrsnRsn=312427" target="_blank" rel="noreferrer noopener" style="word-break: break-all;
                    white-space: normal;">OAR 333-500-0032(2)(c)</a></span>
                  </mat-radio-button>
                  <mat-radio-button value="Low Occupancy Acute Care Hospital">
                    <span class="font-semibold text-lg underline pr-4">Low Occupancy Acute Care Hospital (25 beds or
                      less)</span>
                    <span>See <a href="https://secure.sos.state.or.us/oard/viewSingleRule.action?ruleVrsnRsn=312427" target="_blank" rel="noreferrer noopener" style="word-break: break-all;
                    white-space: normal;">OAR 333-500-0032(2)(b)</a></span>
                  </mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="classificationForm.get('classification')?.invalid">
                  You must select a classification level
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
      <button class="text-xl" mat-raised-button matStepperNext type="button">Next</button>
    </mat-step>

    <!--
      Demographics
    -->
    <mat-step>
      <ng-template matStepLabel>
        <span matTooltip="Demographics" matTooltipPosition="below" [matTooltipShowDelay]="500">Demographics</span>
      </ng-template>
      <div class="pb-2">
        <span class="font-semibold text-xl">Demographics</span>
      </div>

      <div class="flex flex-col md:flex-row gap-4">
        <div class="flex flex-col md:w-1/2">
          <form [formGroup]="licenseForm">
            <mat-card>
              <mat-card-content>
                <div class="flex flex-col gap-2">
                  <div class="flex flex-col md:flex-row gap-2 pb-4">
                    <div class="flex flex-col gap-2 md:w-1/2">
                      <div class="flex flex-row gap-4 items-center">
                        <span class="font-semibold">Hospital Legal Name</span>
                      </div>

                      <mat-form-field>
                        <mat-label>Legal Name</mat-label>
                        <input matInput formControlName="entityName">
                        <mat-error *ngIf="licenseForm.get('entityName')?.hasError('required')">
                          You must include a name.
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/2">
                      <span class="font-semibold">DBA (Doing Business As) Name</span>
                      <mat-form-field>
                        <mat-label>DBA (Doing Business As) Name</mat-label>
                        <input matInput formControlName="hospitalDBAName">
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row gap-2 pb-4">
                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Hospital Phone</span>
                      <mat-form-field>
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="hospitalPhone" mask="000-000-0000">
                        <mat-error *ngIf="licenseForm.get('hospitalPhone')?.hasError('required')">
                          Phone number required
                        </mat-error>
                        <mat-error *ngIf="licenseForm.get('hospitalPhone')?.hasError('pattern')">
                          Format number as 000-000-0000
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Hospital Email</span>
                      <mat-form-field>
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="hospitalEmail">
                        <mat-error *ngIf="licenseForm.get('hospitalEmail')?.hasError('required')">
                          Email is required
                        </mat-error>
                        <mat-error *ngIf="licenseForm.get('hospitalEmail')?.hasError('email')">
                          Not a valid email
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Hospital Fax</span>
                      <mat-form-field>
                        <mat-label>Fax</mat-label>
                        <input matInput formControlName="hospitalFax" mask="000-000-0000">
                        <mat-error *ngIf="licenseForm.get('hospitalFax')?.invalid">
                          Format number as 000-000-0000
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row w-full">
                    <div class="flex flex-col w-1/2">
                      <span class="font-semibold">Accredited?</span>
                      <mat-radio-group aria-label="Select an option" formControlName="accredited" class="flex flex-row items-start gap-1">
                        <mat-radio-button [value]="true" class="m-0">Yes</mat-radio-button>
                        <mat-radio-button [value]="false" class="m-0">No</mat-radio-button>
                        <mat-error *ngIf="this.licenseForm.get('accredited')?.touched && licenseForm.get('accredited')?.invalid">
                          You must select an option
                        </mat-error>
                      </mat-radio-group>
                    </div>

                    <div class="flex flex-col gap-2 w-1/2" *ngIf="licenseForm.get('accredited')?.value">
                      <span class="font-semibold">Accrediting Agency</span>
                      <mat-form-field class="flex flex-col">
                        <mat-label>Accrediting Agency</mat-label>
                        <mat-select formControlName="accreditingAgency">
                          <mat-option value="The Joint Commission">The Joint Commission</mat-option>
                          <mat-option value="Det Norske Veritas- Healthcare (DNV)">Det Norske Veritas- Healthcare (DNV)</mat-option>
                          <mat-option value="Center for Improvement in Healthcare Quality (CIHQ)">Center for Improvement in Healthcare Quality (CIHQ)</mat-option>
                          <mat-option value="Accreditation Commission for Health Care (ACHC)">Accreditation Commission for Health Care (ACHC)</mat-option>
                        </mat-select>
                        <mat-error *ngIf="validateAccreditingAgency()">This field is required</mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row w-full" *ngIf="licenseForm.get('accredited')?.value">
                    <div class="flex flex-col gap-2 w-1/2">
                      <span class="font-semibold">Does the hospital have deemed status?</span>
                      <mat-radio-group aria-label="Select an option" formControlName="deemed" class="flex flex-row items-center gap-1">
                        <mat-radio-button [value]="true" class="m-0">Yes</mat-radio-button>
                        <mat-radio-button [value]="false" class="m-0">No</mat-radio-button>
                      </mat-radio-group>
                      <mat-error *ngIf="validateDeemed()">This field is required</mat-error>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row gap-2">
                    <div class="flex flex-col gap-2 md:w-1/2">
                      <span class="font-semibold">Fiscal Year Ending Date (MM/DD)</span>
                      <mat-form-field>
                        <mat-label>Fiscal Year Ending Date (MM/DD)</mat-label>
                        <input matInput formControlName="fiscalYearEnd">
                        <mat-error *ngIf="licenseForm.get('fiscalYearEnd')?.hasError('required')">
                          Fiscal Year Date required
                        </mat-error>
                        <mat-error *ngIf="licenseForm.get('fiscalYearEnd')?.hasError('pattern')">
                          Format Date as MM/DD
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row">
                    <div class="flex flex-col gap-2">
                      <span class="font-semibold">Ownership Category</span>
                      <span>(If non-profit, partnership, corporation, or LLC, list each person having five percent of more interest on a separate page.)</span>
                      <mat-form-field class="flex flex-col md:w-1/2">
                        <mat-label>Ownership Category</mat-label>
                        <mat-select formControlName="ownershipCategory" [multiple]="true">
                          <mat-option value="Church">Church</mat-option>
                          <mat-option value="State">State</mat-option>
                          <mat-option value="Health District">Health District</mat-option>
                          <mat-option value="Partnership">Partnership</mat-option>
                          <mat-option value="City">City</mat-option>
                          <mat-option value="County">County</mat-option>
                          <mat-option value="Individual">Individual</mat-option>
                          <mat-option value="Corporation or LLC">Corporation or LLC</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </form>
        </div>

        <div class="flex flex-col md:w-1/2 gap-4">
          <mat-card>
            <mat-card-content>
              <div class="flex flex-col gap-4">
                <address [entityId]="license.id"
                         [entityType]="sharedService.hospitalLicense"
                         [canEdit]="!locked"
                         [limitEntries]="true"
                         [isRenewal]="license.isRenewal ?? false"></address>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

      <div class="flex flex-col md:flex-row md:gap-4 pt-4">
        <button class="text-xl" mat-raised-button matStepperPrevious type="button">Back</button>
        <button class="text-xl" mat-raised-button matStepperNext type="button">Next</button>
      </div>
    </mat-step>

    <!--
      Hospital Owner(s)
    -->
    <mat-step>
      <ng-template matStepLabel>
        <span matTooltip="Hospital Owner(s)" matTooltipPosition="below" [matTooltipShowDelay]="500">Owner(s)</span>
      </ng-template>
      <ng-template matStepContent>
        <div class="flex flex-col gap-2">
          <span class="text-xl font-semibold">Owner Information</span>
          <span class="text-lg">
            Provide contact information for each of the owners
          </span>

          <entity-owner [entityId]="license.id"
                        [entityType]="sharedService.hospitalLicense"
                        [entityGuid]="license.licenseId ?? ''"
                        [statuses]="license.statuses"
                        [canChange]="false"
                        [isRenewal]="license.isRenewal ?? false">
          </entity-owner>
        </div>

        <div class="flex flex-col md:flex-row md:gap-4 pt-4">
          <button class="text-xl" mat-raised-button matStepperPrevious type="button">Back</button>
          <button class="text-xl" mat-raised-button matStepperNext type="button">Next</button>
        </div>
      </ng-template>
    </mat-step>

    <!--
      Contacts
    -->
    <mat-step>
      <ng-template matStepLabel>
        <span matTooltip="Contacts" matTooltipPosition="below" [matTooltipShowDelay]="500">Contacts</span>
      </ng-template>
      <div class="pb-2">
        <span class="font-semibold text-xl">Key Contact Information</span>
      </div>

        <div class="flex flex-col gap-2">
          <form [formGroup]="contactForm" class="flex flex-col gap-2">

            <div class="flex flex-col w-full gap-2">
              <div class="flex flex-col md:flex-row md:gap-2">
                <div class="flex flex-col gap-4 md:w-1/3" *ngIf="!classificationForm.get('isSicf')?.value">
                  <span class="text-lg font-semibold">Is this application for a hospital satellite for which the main hospital is located outside of Oregon?:</span>
                  <mat-form-field appearance="fill" class="flex-col gap-2">
                    <input matInput formControlName="mainHospitalOutOfState" style="display: none;">
                    <mat-radio-group aria-labelledby="main hospital out of state" formControlName="mainHospitalOutOfState" class="flex flex-col gap-2 ">
                      <mat-radio-button [value]="true">
                        <span class="font-semibold text-lg underline pr-4">Yes</span>
                      </mat-radio-button>
                      <mat-radio-button [value]="false">
                        <span class="font-semibold text-lg underline pr-4">No</span>
                      </mat-radio-button>
                    </mat-radio-group>
                    <mat-error *ngIf="contactForm.get('mainHospitalOutOfState')?.invalid">
                      You must select an option
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="flex flex-col w-1/3 gap-4">
                  <span class="text-lg font-semibold">Hospital Administrator</span>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="hospitalAdminName" [errorStateMatcher]="contactNameErrorMatchers['hospitalAdminName']">
                    <mat-error *ngIf="contactForm.get('hospitalAdminName')?.touched && contactForm.getError('duplicateContactNames')?.['hospitalAdminName'] as conflicts">
                      Name must differ from: {{ conflicts.join(', ') }}.
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('hospitalAdminName')?.hasError('required')">
                      Name is required
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="hospitalAdminEmail">
                    <mat-error *ngIf="contactForm.get('hospitalAdminEmail')?.hasError('required')">
                      Email is required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('hospitalAdminEmail')?.hasError('email')">
                      Not a valid email
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Phone</mat-label>
                    <input matInput formControlName="hospitalAdminPhone" mask="000-000-0000">
                    <mat-error *ngIf="contactForm.get('hospitalAdminPhone')?.hasError('required')">
                      Phone number required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('hospitalAdminPhone')?.hasError('pattern')">
                      Format number as 000-000-0000
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="flex flex-col w-1/3 gap-4">
                  <span class="text-lg font-semibold">Emergency Contact</span>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="emergencyContactName" [errorStateMatcher]="contactNameErrorMatchers['emergencyContactName']">
                    <mat-error *ngIf="contactForm.get('emergencyContactName')?.touched && contactForm.getError('duplicateContactNames')?.['emergencyContactName'] as conflicts">
                      Name must differ from: {{ conflicts.join(', ') }}.
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('emergencyContactName')?.hasError('required')">
                      Name is required
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="emergencyContactEmail">
                    <mat-error *ngIf="contactForm.get('emergencyContactEmail')?.hasError('required')">
                      Email is required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('emergencyContactEmail')?.hasError('email')">
                      Not a valid email
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Phone</mat-label>
                    <input matInput formControlName="emergencyContactPhone" mask="000-000-0000">
                    <mat-error *ngIf="contactForm.get('emergencyContactPhone')?.hasError('required')">
                      Phone number required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('emergencyContactPhone')?.hasError('pattern')">
                      Format number as 000-000-0000
                    </mat-error>
                  </mat-form-field>
                </div>

              </div>
              <div class="flex flex-col md:flex-row md:gap-2">
                <div class="flex flex-col w-1/3 gap-4">
                  <span class="text-lg font-semibold">Chief Nursing Officer/Nurse Executive</span>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="chiefNurseName" [errorStateMatcher]="contactNameErrorMatchers['chiefNurseName']">
                    <mat-error *ngIf="contactForm.get('chiefNurseName')?.touched && contactForm.getError('duplicateContactNames')?.['chiefNurseName'] as conflicts">
                      Name must differ from: {{ conflicts.join(', ') }}.
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('chiefNurseName')?.hasError('required')">
                      Name is required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('chiefNurseName')?.hasError('invalidChiefNurseName')">
                      Matches an existing Chief Nursing Officer/Nurse Executive or Hospital Administrator
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="chiefNurseEmail">
                    <mat-error *ngIf="contactForm.get('chiefNurseEmail')?.hasError('required')">
                      Email is required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('chiefNurseEmail')?.hasError('email')">
                      Not a valid email
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Phone</mat-label>
                    <input matInput formControlName="chiefNursePhone" mask="000-000-0000">
                    <mat-error *ngIf="contactForm.get('chiefNursePhone')?.hasError('required')">
                      Phone number required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('chiefNursePhone')?.hasError('pattern')">
                      Format number as 000-000-0000
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="flex flex-col w-1/3 gap-4">
                  <span class="text-lg font-semibold">Nurse Manager Co-Chair</span>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="nurseManagerName" [errorStateMatcher]="contactNameErrorMatchers['nurseManagerName']">
                    <mat-error *ngIf="contactForm.get('nurseManagerName')?.touched && contactForm.getError('duplicateContactNames')?.['nurseManagerName'] as conflicts">
                      Name must differ from: {{ conflicts.join(', ') }}.
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('nurseManagerName')?.hasError('required')">
                      Name is required
                    </mat-error>
                  </mat-form-field>
                  <div class="flex flex-col md:flex-row md:gap-2">
                    <mat-form-field class="flex flex-col w-full md:w-1/2">
                      <mat-label>Title</mat-label>
                      <input matInput formControlName="nurseManagerTitle">
                      <mat-error *ngIf="contactForm.get('nurseManagerTitle')?.hasError('required')">
                        Title is required
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full md:w-1/2">
                      <mat-label>Phone</mat-label>
                      <input matInput formControlName="nurseManagerPhone" mask="000-000-0000">
                      <mat-error *ngIf="contactForm.get('nurseManagerPhone')?.hasError('required')">
                        Phone number required
                      </mat-error>
                      <mat-error *ngIf="contactForm.get('nurseManagerPhone')?.hasError('pattern')">
                        Format number as 000-000-0000
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="nurseManagerEmail">
                    <mat-error *ngIf="contactForm.get('nurseManagerEmail')?.hasError('required')">
                      Email is required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('nurseManagerEmail')?.hasError('email')">
                      Not a valid email
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="flex flex-col w-1/3 gap-4">
                  <span class="text-lg font-semibold">Direct Care Co-Chair</span>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="directCareName" [errorStateMatcher]="contactNameErrorMatchers['directCareName']">
                    <mat-error *ngIf="contactForm.get('directCareName')?.touched && contactForm.getError('duplicateContactNames')?.['directCareName'] as conflicts">
                      Name must differ from: {{ conflicts.join(', ') }}.
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('directCareName')?.hasError('required')">
                      Name is required
                    </mat-error>
                  </mat-form-field>
                  <div class="flex flex-col md:flex-row md:gap-2">
                    <mat-form-field class="flex flex-col w-full md:w-1/2">
                      <mat-label>Title</mat-label>
                      <input matInput formControlName="directCareTitle">
                      <mat-error *ngIf="contactForm.get('directCareTitle')?.hasError('required')">
                        Title is required
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field class="flex flex-col w-full md:w-1/2">
                      <mat-label>Phone</mat-label>
                      <input matInput formControlName="directCarePhone" mask="000-000-0000">
                      <mat-error *ngIf="contactForm.get('directCarePhone')?.hasError('required')">
                        Phone number required
                      </mat-error>
                      <mat-error *ngIf="contactForm.get('directCarePhone')?.hasError('pattern')">
                        Format number as 000-000-0000
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="directCareEmail">
                    <mat-error *ngIf="contactForm.get('directCareEmail')?.hasError('required')">
                      Email is required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('directCareEmail')?.hasError('email')">
                      Not a valid email
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="flex flex-col md:flex-row md:gap-2">
                <div class="flex flex-col w-1/3 gap-4">
                  <span class="text-lg font-semibold">Emergency Department Director</span>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="emergencyDepartmentDirectorName" [errorStateMatcher]="contactNameErrorMatchers['emergencyDepartmentDirectorName']">
                    <mat-error *ngIf="contactForm.get('emergencyDepartmentDirectorName')?.touched && contactForm.getError('duplicateContactNames')?.['emergencyDepartmentDirectorName'] as conflicts">
                      Name must differ from: {{ conflicts.join(', ') }}.
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('emergencyDepartmentDirectorName')?.hasError('required')">
                      Name is required
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="emergencyDepartmentDirectorEmail">
                    <mat-error *ngIf="contactForm.get('emergencyDepartmentDirectorEmail')?.hasError('required')">
                      Email is required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('emergencyDepartmentDirectorEmail')?.hasError('email')">
                      Not a valid email
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Phone</mat-label>
                    <input matInput formControlName="emergencyDepartmentDirectorPhone" mask="000-000-0000">
                    <mat-error *ngIf="contactForm.get('emergencyDepartmentDirectorPhone')?.hasError('required')">
                      Phone number required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('emergencyDepartmentDirectorPhone')?.hasError('pattern')">
                      Format number as 000-000-0000
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="flex flex-col w-1/3 gap-4">
                  <span class="text-lg font-semibold">Professional/Technical Manager Co-Chair</span>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="technicalManagerCoChairName" [errorStateMatcher]="contactNameErrorMatchers['technicalManagerCoChairName']">
                    <mat-error *ngIf="contactForm.get('technicalManagerCoChairName')?.touched && contactForm.getError('duplicateContactNames')?.['technicalManagerCoChairName'] as conflicts">
                      Name must differ from: {{ conflicts.join(', ') }}.
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('technicalManagerCoChairName')?.hasError('required')">
                      Name is required
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="technicalManagerCoChairEmail">
                    <mat-error *ngIf="contactForm.get('technicalManagerCoChairEmail')?.hasError('required')">
                      Email is required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('technicalManagerCoChairEmail')?.hasError('email')">
                      Not a valid email
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Phone</mat-label>
                    <input matInput formControlName="technicalManagerCoChairPhone" mask="000-000-0000">
                    <mat-error *ngIf="contactForm.get('technicalManagerCoChairPhone')?.hasError('required')">
                      Phone number required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('technicalManagerCoChairPhone')?.hasError('pattern')">
                      Format number as 000-000-0000
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="flex flex-col w-1/3 gap-4">
                  <span class="text-lg font-semibold">Professional/Technical Staff Co-Chair</span>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="technicalStaffCoChairName" [errorStateMatcher]="contactNameErrorMatchers['technicalStaffCoChairName']">
                    <mat-error *ngIf="contactForm.get('technicalStaffCoChairName')?.touched && contactForm.getError('duplicateContactNames')?.['technicalStaffCoChairName'] as conflicts">
                      Name must differ from: {{ conflicts.join(', ') }}.
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('technicalStaffCoChairName')?.hasError('required')">
                      Name is required
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="technicalStaffCoChairEmail">
                    <mat-error *ngIf="contactForm.get('technicalStaffCoChairEmail')?.hasError('required')">
                      Email is required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('technicalStaffCoChairEmail')?.hasError('email')">
                      Not a valid email
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Phone</mat-label>
                    <input matInput formControlName="technicalStaffCoChairPhone" mask="000-000-0000">
                    <mat-error *ngIf="contactForm.get('technicalStaffCoChairPhone')?.hasError('required')">
                      Phone number required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('technicalStaffCoChairPhone')?.hasError('pattern')">
                      Format number as 000-000-0000
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="flex flex-col md:flex-row md:gap-2">
                <div class="flex flex-col w-1/3 gap-4">
                  <span class="text-lg font-semibold">Service Staffing Committee Manager Co-Chair</span>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="serviceStaffingCommitteeManagerCoChairName" [errorStateMatcher]="contactNameErrorMatchers['serviceStaffingCommitteeManagerCoChairName']">
                    <mat-error *ngIf="contactForm.get('serviceStaffingCommitteeManagerCoChairName')?.touched && contactForm.getError('duplicateContactNames')?.['serviceStaffingCommitteeManagerCoChairName'] as conflicts">
                      Name must differ from: {{ conflicts.join(', ') }}.
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('serviceStaffingCommitteeManagerCoChairName')?.hasError('required')">
                      Name is required
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="serviceStaffingCommitteeManagerCoChairEmail">
                    <mat-error *ngIf="contactForm.get('serviceStaffingCommitteeManagerCoChairEmail')?.hasError('required')">
                      Email is required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('serviceStaffingCommitteeManagerCoChairEmail')?.hasError('email')">
                      Not a valid email
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Phone</mat-label>
                    <input matInput formControlName="serviceStaffingCommitteeManagerCoChairPhone" mask="000-000-0000">
                    <mat-error *ngIf="contactForm.get('serviceStaffingCommitteeManagerCoChairPhone')?.hasError('required')">
                      Phone number required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('serviceStaffingCommitteeManagerCoChairPhone')?.hasError('pattern')">
                      Format number as 000-000-0000
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="flex flex-col w-1/3 gap-4">
                  <span class="text-lg font-semibold">Service Staffing Committee Staff Co-Chair</span>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="serviceStaffingCommitteeStaffCoChairName" [errorStateMatcher]="contactNameErrorMatchers['serviceStaffingCommitteeStaffCoChairName']">
                    <mat-error *ngIf="contactForm.get('serviceStaffingCommitteeStaffCoChairName')?.touched && contactForm.getError('duplicateContactNames')?.['serviceStaffingCommitteeStaffCoChairName'] as conflicts">
                      Name must differ from: {{ conflicts.join(', ') }}.
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('serviceStaffingCommitteeStaffCoChairName')?.hasError('required')">
                      Name is required
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="serviceStaffingCommitteeStaffCoChairEmail">
                    <mat-error *ngIf="contactForm.get('serviceStaffingCommitteeStaffCoChairEmail')?.hasError('required')">
                      Email is required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('serviceStaffingCommitteeStaffCoChairEmail')?.hasError('email')">
                      Not a valid email
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Phone</mat-label>
                    <input matInput formControlName="serviceStaffingCommitteeStaffCoChairPhone" mask="000-000-0000">
                    <mat-error *ngIf="contactForm.get('serviceStaffingCommitteeStaffCoChairPhone')?.hasError('required')">
                      Phone number required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('serviceStaffingCommitteeStaffCoChairPhone')?.hasError('pattern')">
                      Format number as 000-000-0000
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="flex flex-col w-1/3 gap-4">
                  <span class="text-lg font-semibold">Person who filled out this application</span>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="filerName">
                    <mat-error *ngIf="contactForm.get('filerName')?.hasError('required')">
                      Name is required
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="filerEmail">
                    <mat-error *ngIf="contactForm.get('filerEmail')?.hasError('required')">
                      Email is required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('filerEmail')?.hasError('email')">
                      Not a valid email
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="flex flex-col w-full">
                    <mat-label>Phone</mat-label>
                    <input matInput formControlName="filerPhone" mask="000-000-0000">
                    <mat-error *ngIf="contactForm.get('filerPhone')?.hasError('required')">
                      Phone number required
                    </mat-error>
                    <mat-error *ngIf="contactForm.get('filerPhone')?.hasError('pattern')">
                      Format number as 000-000-0000
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="flex flex-col gap-4 md:w-1/3">
              <span class="text-lg font-semibold">Does this facility have union representation?:</span>
              <mat-form-field appearance="fill" class="flex-col gap-2">
                <input matInput formControlName="hasUnionRepresentation" style="display: none;">
                <mat-radio-group aria-labelledby="has union representation" formControlName="hasUnionRepresentation" class="flex flex-col gap-2 ">
                  <mat-radio-button [value]="true">
                    <span class="font-semibold text-lg underline pr-4">Yes</span>
                  </mat-radio-button>
                  <mat-radio-button [value]="false">
                    <span class="font-semibold text-lg underline pr-4">No</span>
                  </mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="contactForm.get('hasUnionRepresentation')?.invalid">
                  You must select an option
                </mat-error>
              </mat-form-field>
            </div>

          </form>

          <div class="flex flex-col gap-4" *ngIf="contactForm.get('hasUnionRepresentation')?.value">
            <div class="pb-2">
              <span class="font-semibold text-xl">Exclusive Representative Contact Information</span>
            </div>

            <div class="flex flex-col gap-4">
              <span>The Exclusive Representative is a union that represents hospital staff.</span>
              <span>This form allows you to enter information for up to three Exclusive Representatives at your hospital.</span>
            </div>

            <!-- Add Contact Button -->
            <div *ngIf="!showRepresentativeContactForm && !locked">
              <button mat-raised-button color="primary" type="button" (click)="showAddRepresentativeContactForm()">
                <mat-icon>add</mat-icon>
                Add Representative Contact
              </button>
            </div>

            <!-- Add/Edit Representative Contact Form -->
            <mat-card *ngIf="showRepresentativeContactForm && !locked">
              <mat-card-content>
                <div class="flex flex-col gap-2">
                  <div class="pb-1">
                    <span class="font-semibold text-xl">{{ editingRepresentativeContact ? 'Edit' : 'Add' }} Representative Contact</span>
                  </div>
                  <form [formGroup]="representativeContactForm">
                    <div class="flex flex-col gap-2">
                      <div class="flex flex-col md:flex-row gap-2">
                        <div class="flex flex-col gap-2 md:w-1/2">
                          <mat-form-field>
                            <mat-label>Select the Exclusive Representative that represents hospital staff</mat-label>
                            <mat-select formControlName="representativeType">
                              <mat-option *ngFor="let option of representativeTypeOptions" [value]="option">
                                {{ option }}
                              </mat-option>
                            </mat-select>
                            <mat-error *ngIf="representativeContactForm.get('representativeType')?.hasError('required')">
                              Representative Type is required
                            </mat-error>
                          </mat-form-field>
                        </div>

                        <div class="flex flex-col gap-2 md:w-1/2" *ngIf="representativeContactForm.get('representativeType')?.value === 'Other'">
                          <mat-form-field>
                            <mat-label>If other, list the Exclusive Representative:</mat-label>
                            <input matInput formControlName="representativeTypeOther" placeholder="Enter representative type">
                            <mat-error *ngIf="representativeContactForm.get('representativeTypeOther')?.hasError('required')">
                              Please specify the representative type
                            </mat-error>
                          </mat-form-field>
                        </div>

                        <div class="flex flex-col gap-2 md:w-1/2">
                          <mat-form-field>
                            <mat-label>Which hospital staff are represented by this Exclusive Representative?</mat-label>
                            <input matInput formControlName="representativeStaff" placeholder="Represented Staff">
                            <mat-error *ngIf="representativeContactForm.get('representativeStaff')?.hasError('required')">
                              Representative Staff is required
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>

                      <div class="flex flex-col md:flex-row gap-2">
                        <div class="flex flex-col gap-2 md:w-1/3">
                          <mat-form-field>
                            <mat-label>Name of Exclusive Representative Contact Person</mat-label>
                            <input matInput formControlName="contactName">
                            <mat-error *ngIf="representativeContactForm.get('contactName')?.hasError('required')">
                              Contact Name is required
                            </mat-error>
                          </mat-form-field>
                        </div>

                        <div class="flex flex-col gap-2 md:w-1/3">
                          <mat-form-field>
                            <mat-label>Phone of Exclusive Representative Contact Person</mat-label>
                            <input matInput formControlName="contactPhone" mask="000-000-0000">
                            <mat-error *ngIf="representativeContactForm.get('contactPhone')?.hasError('required')">
                              Contact Phone is required
                            </mat-error>
                            <mat-error *ngIf="representativeContactForm.get('contactPhone')?.hasError('pattern')">
                              Format number as 000-000-0000
                            </mat-error>
                          </mat-form-field>
                        </div>

                        <div class="flex flex-col gap-2 md:w-1/3">
                          <mat-form-field>
                            <mat-label>Email of Exclusive Representative Contact Person</mat-label>
                            <input matInput formControlName="contactEmail">
                            <mat-error *ngIf="representativeContactForm.get('contactEmail')?.hasError('required')">
                              Contact Email is required
                            </mat-error>
                            <mat-error *ngIf="representativeContactForm.get('contactEmail')?.hasError('email')">
                              Not a valid email
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>

                      <div class="flex flex-row gap-2 justify-end">
                        <button mat-button type="button" (click)="cancelEditRepresentativeContact()" *ngIf="editingRepresentativeContact">
                          Cancel
                        </button>
                        <button mat-raised-button color="primary" type="button"
                                [disabled]="representativeContactForm.invalid"
                                (click)="saveRepresentativeContact()">
                          {{ editingRepresentativeContact ? 'Update' : 'Add' }} Contact
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </mat-card-content>
            </mat-card>

            <!-- Representative Contacts Table -->
            <mat-card *ngIf="!showRepresentativeContactForm && license.representativeContacts.length > 0">
              <mat-card-content>
                <div class="flex flex-col gap-2">
                  <div class="pb-1">
                    <span class="font-semibold text-xl">Representative Contacts</span>
                  </div>
                  <div class="mat-elevation-z2">
                    <mat-table mat-table [dataSource]="representativeContactDataSource" matSort #representativeContactSort="matSort" class="w-full">
                      <ng-container matColumnDef="representativeType">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="">Representative Type</mat-header-cell>
                        <mat-cell *matCellDef="let contact">
                          {{ contact.representativeType }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="representativeStaff">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="">Representative Staff</mat-header-cell>
                        <mat-cell *matCellDef="let contact">
                          {{ contact.representativeStaff }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="contactName">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="">Contact Name</mat-header-cell>
                        <mat-cell *matCellDef="let contact">
                          {{ contact.contactName }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="contactPhone">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="">Contact Phone</mat-header-cell>
                        <mat-cell *matCellDef="let contact">
                          {{ contact.contactPhone }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="contactEmail">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="">Contact Email</mat-header-cell>
                        <mat-cell *matCellDef="let contact">
                          {{ contact.contactEmail }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="">Actions</mat-header-cell>
                        <mat-cell *matCellDef="let contact">
                          <button mat-icon-button color="primary"
                                  (click)="editRepresentativeContact(contact)"
                                  [disabled]="locked"
                                  matTooltip="Edit">
                            <mat-icon>edit</mat-icon>
                          </button>
                          <button mat-icon-button color="warn"
                                  (click)="deleteRepresentativeContact(contact)"
                                  [disabled]="locked"
                                  matTooltip="Delete">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </mat-cell>
                      </ng-container>

                      <mat-header-row *matHeaderRowDef="representativeContactColumns"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: representativeContactColumns"></mat-row>
                    </mat-table>
                    <mat-paginator [pageSizeOptions]="[5, 10, 20]" #representativeContactPaginator="matPaginator">
                    </mat-paginator>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <div *ngIf="!showRepresentativeContactForm && license.representativeContacts.length === 0 && locked">
              <span class="portal-muted">No representative contacts have been added.</span>
            </div>
          </div>

        </div>

      <div class="flex flex-col md:flex-row md:gap-4 pt-4">
        <button class="text-xl" mat-raised-button matStepperPrevious type="button">Back</button>
        <button class="text-xl" mat-raised-button matStepperNext type="button">Next</button>
      </div>
    </mat-step>

    <!-- Services -->
    <mat-step>
      <ng-template matStepLabel>
        <span matTooltip="Services" matTooltipPosition="below" [matTooltipShowDelay]="500">Services</span>
      </ng-template>
      <div class="pb-2">
        <span class="font-semibold text-xl">Services</span>
      </div>

      <div class="flex flex-col md:flex-row gap-4">
        <div class="flex flex-col md:w-1/2" *ngIf="!viewingBuilding && !viewingSatelliteLocation">
          <form [formGroup]="servicesForm">
            <mat-card>
              <mat-card-content>
                <div class="flex flex-col gap-2">
                  <div class="flex flex-col md:flex-row gap-2 pb-8">
                    <div class="flex flex-col gap-2 md:w-1/2">
                      <span class="font-semibold">Total on-campus inpatient beds</span>
                      <mat-form-field>
                        <mat-label>Inpatient beds</mat-label>
                        <input type="number" matInput formControlName="inpatientBeds" min="0">
                        <mat-error *ngIf="servicesForm.get('inpatientBeds')?.invalid">
                          You must enter a number
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/2" *ngIf="!classificationForm.get('isSicf')?.value">
                      <span class="font-semibold">Total on-campus inpatient psychiatric beds</span>
                      <mat-form-field>
                        <mat-label>Inpatient Psychiatric Beds</mat-label>
                        <input type="number" matInput formControlName="inpatientPsychiatricBeds" min="0">
                        <mat-error *ngIf="servicesForm.get('inpatientPsychiatricBeds')?.invalid">
                          You must enter a number
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row gap-2 pb-8" *ngIf="!classificationForm.get('isSicf')?.value">
                    <div class="flex flex-col gap-2 md:w-2/4">
                      <span class="font-semibold">Total satellite inpatient psychiatric beds</span>
                      <mat-form-field>
                        <mat-label>Satellite Inpatient Psychiatric Beds</mat-label>
                        <input type="number" matInput formControlName="satelliteInpatientPsychiatricBeds" min="0">
                        <mat-error *ngIf="servicesForm.get('satelliteInpatientPsychiatricBeds')?.invalid">
                          You must enter a number
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/4" *ngIf="classificationForm.get('classification')?.value === 'General Hospital' ||
                                                                     classificationForm.get('classification')?.value === 'Psychiatric Hospital'">
                      <span class="font-semibold">Swing Beds?</span>
                      <mat-radio-group aria-label="Select an option" formControlName="swingBeds" class="flex flex-row items-start gap-1">
                        <mat-radio-button [value]="true" class="m-0">Yes</mat-radio-button>
                        <mat-radio-button [value]="false" class="m-0">No</mat-radio-button>
                      </mat-radio-group>
                      <mat-error *ngIf="validateSwingBeds()">
                        You must select an option
                      </mat-error>
                    </div>
                  </div>

                  <div *ngIf="!classificationForm.get('isSicf')?.value" class="flex flex-col gap-2 pb-8">
                    <span class="font-semibold">Services Provided</span>
                    <span>(check all that apply) (All services are required for General Hospitals)</span>
                    <div class="flex flex-row gap-2">
                      <mat-checkbox formControlName="maternity" value="maternity">Maternity</mat-checkbox>
                      <mat-checkbox formControlName="surgical" value="surgical">Surgical</mat-checkbox>
                      <mat-checkbox formControlName="emergency" value="emergency">Emergency</mat-checkbox>
                    </div>

                    <span class="font-semibold" *ngIf="classificationForm.get('classification')?.value === 'General Hospital'">
                      To submit a general hospital application you must select all services. If you do not select all services
                      your application will be rejected unless you have an approved waiver.
                      If you have any questions you can email the licensing office at:
                      <a href="mailto:mailbox.hclc@odhsoha.oregon.gov">mailbox.hclc&#64;odhsoha.oregon.gov</a>
                    </span>

                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </form>
        </div>
      </div>

      <div class="flex flex-col md:flex-row md:gap-4 pt-4">
        <button class="text-xl" mat-raised-button matStepperPrevious type="button">Back</button>
        <button class="text-xl" mat-raised-button matStepperNext type="button">Next</button>
      </div>
    </mat-step>

    <!-- On Campus / Satellite Locations -->
    <mat-step *ngIf="!classificationForm.get('isSicf')?.value">
      <ng-template matStepLabel>
        <span matTooltip="Services" matTooltipPosition="below" [matTooltipShowDelay]="500">On Campus / Satellite Locations</span>
      </ng-template>
      <div class="pb-2">
        <span class="font-semibold text-xl">On Campus Buildings / Satellite Locations</span>
      </div>

      <div class="flex flex-col gap-4" *ngIf="!classificationForm.get('isSicf')?.value">
        <div class="flex flex-row gap-4 w-full" [hidden]="viewingSatelliteLocation">
          <mat-card class="flex flex-row w-full gap-4">
            <mat-card-content>
              <div class="flex flex-col gap-4">
                <span class="text-xl font-semibold">On-Campus Buildings</span>
                <span>Complete the “on-campus” building information for below each on-campus provider-based service. An on campus
                  building is any building that is within 250 yards of any exterior wall of the hospital's main building.</span>
                <on-campus-building
                  [canEdit]="!locked"
                  [entityId]="license.id"
                  [entityType]="sharedService.hospitalLicense"
                  [licenseStatuses]="license.statuses"
                  [HospitalLicenseId]="license.licenseId ?? ''"
                  (viewBuilding)="toggleViewingOnCampusBuildings()">
                </on-campus-building>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="flex flex-row gap-4 w-full" [hidden]="viewingBuilding">
          <mat-card class="flex flex-row w-full gap-4">
            <mat-card-content>
              <div class="flex flex-col gap-4">
                <span class="text-xl font-semibold">Off-Campus Satellite Locations</span>
                <span>Complete a “Satellite Information Form” for each satellite operated by the hospital. A “satellite location” is any location that is
                  geographically separate from the main hospital building and is more than 250 yards from any exterior wall of the hospital's main building
                  as measured by radial distance (“as a crow flies”).</span>
                <satellite-location
                  [canEdit]="!locked"
                  [entityId]="license.id"
                  [entityType]="sharedService.hospitalLicense"
                  [licenseStatuses]="license.statuses"
                  [HospitalLicenseId]="license.licenseId ?? ''"
                  (viewSatelliteLocation)="toggleViewingSatelliteLocation()">
                </satellite-location>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

      <div class="flex flex-col md:flex-row md:gap-4 pt-4">
        <button class="text-xl" mat-raised-button matStepperPrevious type="button">Back</button>
        <button class="text-xl" mat-raised-button matStepperNext type="button">Next</button>
      </div>
    </mat-step>

    <!--
      Submit Application
    -->
    <mat-step>
      <ng-template matStepLabel>
        <span matTooltip="Submit Application" matTooltipPosition="below" [matTooltipShowDelay]="500">Submit Application</span>
      </ng-template>
      <div class="flex flex-col md:flex-row gap-4">
        <div class="flex flex-col gap-4 md:w-1/2" *ngIf="!locked">
          <span class="font-semibold text-lg">I declare, under penalty of perjury, that I have examined this application and all attachments and that
            to the best of my knowledge and belief, this information is true, correct, and complete. I will notify the
            Health Care Regulation and Quality Improvement Section, in writing, of any changes in this
            information within 30 days of any such change.</span>

          <span *ngIf="!classificationForm.get('isSicf')?.value" class="font-semibold text-lg">Oregon Administrative Rules Chapter 333, Divisions
            500-535 requires that all accredited hospitals provide the Health Care Regulation and Quality
            Improvement Section all accrediting survey and inspection reports, and written evidence of all
            corrective actions and progress reports related to accrediting surveys.</span>

          <span class="font-semibold text-lg">Upload signed administrator signature document</span>

          <button type="button"  class="portal-text-action"
            (click)="downloadReferenceDocument(classificationForm.get('isSicf')?.value ? sharedService.sicfAttestation : sharedService.hospitalAttestation)">
            Download Administrator Attestation Document
          </button>

          <document
            [entityId]="license.id"
            [entityType]="sharedService.hospitalLicense"
            [editable]="!locked"
            [statuses]="license.statuses"
            [types]="hospitalDocumentTypes"
            (fileUploaded)="validateDocuments($event)">
          </document>

          <button *ngIf="licenseForm.valid && contactForm.valid &&
                  validationErrors.length === 0"
                  type="button" class="ml-auto" mat-flat-button color="primary" [disabled]="submitting || validatingLocations || savingStep" (click)="submitLicense()">Submit</button>
        </div>

        <div class="flex flex-col gap-4 md:w-1/2" *ngIf="(!licenseForm.valid || validationErrors.length > 0 || (!classificationForm.valid && !classificationForm.disabled) || !contactForm.valid || !servicesForm.valid) && !licenseForm.disabled">
          <span class="text-xl portal-error">Your Application is Incomplete</span>
          <span class="text-lg portal-error">Missing information must be provided before you can submit your application</span>
          <span class="portal-error pl-8" *ngIf="!classificationForm.valid && !classificationForm.disabled && !locked">Hospital Classification is required</span>
          <span class="portal-error pl-8" *ngIf="!licenseForm.valid && !locked">Demographic Information is Incomplete</span>
          <span class="portal-error pl-8" *ngIf="!contactForm.valid && !locked">Contact Information is Incomplete</span>
          <span class="portal-error pl-8" *ngIf="!servicesForm.valid && !locked">Services Information is Incomplete</span>

          <div *ngFor="let error of validationErrors">
            <span class="portal-error pl-8">{{error}}</span>
          </div>

          <span class="text-lg">If you need assistance with your application, or would like to request a waiver please send an email to:
            <a href="mailto:mailbox.hclc@odhsoha.oregon.gov">mailbox.hclc&#64;odhsoha.oregon.gov</a>. Thank you.
          </span>
        </div>

      </div>

      <div class="flex flex-col gap-4 md:w-1/3" *ngIf="locked">
        <span class="text-xl font-semibold">Thank you for submitting your {{license.isSicf ? 'SICF' : 'Hospital'}} application.</span>

        <a mat-raised-button color="primary" [routerLink]="['/payments']">
          <span class="text-lg">View and pay your application fee</span>
        </a>

        <span class="text-lg">Applications will be processed in the order they are received.
          If you have questions about your application, please email
          <a href="mailto:mailbox.hclc@odhsoha.oregon.gov">mailbox.hclc&#64;odhsoha.oregon.gov</a>. Thank you.
        </span>
      </div>

      <div class="flex flex-col md:flex-row md:gap-4 pt-4">
        <button class="text-xl" mat-raised-button matStepperPrevious>Back</button>
        <button class="text-xl" *ngIf="!approved" mat-raised-button (click)="Stepper.reset()">Reset</button>
        <button class="text-xl" *ngIf="approved" mat-raised-button matStepperNext type="button">Next</button>
      </div>
    </mat-step>

  </mat-stepper>
</div>
